import React from "react";
import Meaning from "./Meaning.js";
import Fotos from "./Fotos.js";
import "./App.css";

export default function Results(props) {
  console.log(props.results);

  if (props.results) {
    return (
      <div className="result">
        <div className="section">
          <h1>Word: {props.results.word}</h1>
          <p className="phonetic">Phonetic: {props.results.phonetic}</p>
        </div>
        <Fotos query={props.results.word} />
        {props.results.meanings.map(function (meaning, index) {
          return (
            <div key={index} className="meaning">
              <Meaning meaning={meaning} />
            </div>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
}
